import {
	TablePage,
	ViewPage,
	EditPage,
	AddPage
} from 'src/views/ping-admin/event-source'
import pathMap from 'src/paths/PathMap_Ping'

class PingEventSourceRoute {
	getConfigurations() {
		return [
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_SOURCE_LIST_VIEW,
				component: TablePage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_SOURCE_DETAILS_VIEW,
				component: ViewPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_SOURCE_EDIT_VIEW,
				component: EditPage
			},
			{
				exact: true,
				path: pathMap.PING_ADMIN_EVENT_SOURCE_ADD_VIEW,
				component: AddPage
			}
		]
	}
}

export default PingEventSourceRoute
